import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'

const state = {
  Parent: {},
  ContentPages: [],
  EditingContentPageId: 0,
  BackupContentPage: null,
  NewContentPage: null,
  UI: {
    activeCategoryTab: '',
    activeMainTab: 'pages'
  },
  FirstTimeOpen: false,
  currentActiveEventTab: ''
}

const getters = {
  Parent: state => state.Parent,
  ContentPages: state => state.ContentPages,
  IsEditing: state => state.EditingContentPageId !== 0,
  EditingContentPage: state => {
    if (state.EditingContentPageId === 0) {
      return {}
    }
    return state.ContentPages.find(contentPage => contentPage.Id === state.EditingContentPageId)
  },
  NewContentPage: state => state.NewContentPage,
  IsAddingNewContentPage: state => state.NewContentPage !== null,
  UI: state => state.UI,
  FirstTimeOpen: state => state.FirstTimeOpen,
  currentActiveEventTab: state => state.currentActiveEventTab
}

const mutations = {
  RESET_MODULE_DATA (state) {
    state.Parent = {}
    state.ContentPages = []
    state.EditingContentPageId = 0
    state.BackupContentPage = null
    state.NewContentPage = null
    // state.FirstTimeOpen = false
    state.UI = {
      activeCategoryTab: '',
      activeMainTab: 'pages'
    }
  },
  [mutationNames.SET_CONTENT_PAGE_PARENT] (state, parent) {
    state.Parent = parent
  },
  [mutationNames.UPDATE_CONTENT_PARENT] (state, payload) {
    Object.assign(state.Parent, payload)
  },
  [mutationNames.SET_CONTENT_PAGES] (state, contentPages) {
    state.ContentPages = contentPages
  },
  [mutationNames.UPDATE_CONTENT_PAGE] (state, { Id, payload }) {
    let contentPage = state.ContentPages.find(contentPage => contentPage.Id === Id)
    if (contentPage) {
      Object.assign(contentPage, payload)
    }
  },
  [mutationNames.UPDATE_CONTENT_PAGE_IMAGE] (state, { Id, payload }) {
    const contentPage = state.ContentPages.find(page => page.Id === Id)
    if (contentPage) {
      contentPage.PostImage = payload.PostImage
    }
  },
  [mutationNames.CREATE_NEW_CONTENT_PAGE] (state, payload) {
    state.NewContentPage = payload
  },
  [mutationNames.UPDATE_NEW_CONTENT_PAGE] (state, payload) {
    state.NewContentPage = Object.assign({}, state.NewContentPage, payload)
  },
  [mutationNames.SET_CONTENT_EDITING_PAGE] (state, contentPageId) {
    state.EditingContentPageId = contentPageId
    state.BackupContentPage = Object.assign({}, state.ContentPages.find(contentPage => contentPage.Id === contentPageId))
  },
  [mutationNames.CANCEL_CONTENT_PAGE_EDITING] (state, BackupContentPage) {
    const index = state.ContentPages.findIndex(contentPage => contentPage.Id === state.EditingContentPageId)
    state.ContentPages.splice(index, 1, BackupContentPage)
  },
  [mutationNames.CLEAR_CONTENT_EDITING_DATA] (state) {
    state.EditingContentPageId = 0
    state.BackupContentPage = null
    state.NewContentPage = null
  },
  UPDATE_UI (state, payload) {
    Object.assign(state.UI, payload)
  },
  setFirstTimeOpenValue (state, payload) {
    state.FirstTimeOpen = payload
  },
  [mutationNames.CURRENT_ACTIVE_EVENT_TAB] (state, payload) {
    state.currentActiveEventTab = payload
  }
}

const actions = {
  async initModule ({getters, commit, dispatch}, subscriptionModuleId) {
    dispatch('resetModuleData')
    const response = await dispatch('populateTextContent', subscriptionModuleId)
    await dispatch('populateTextContentPages', response.Id)
  },
  updateUI ({ commit }, payload) {
    commit('UPDATE_UI', payload)
  },
  resetModuleData ({ commit }) {
    commit('RESET_MODULE_DATA')
  },
  async populateTextContent ({ commit }, subscriptionModuleId) {
    let response = await api.AppModules.getTextModule(subscriptionModuleId)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    commit(mutationNames.SET_CONTENT_PAGE_PARENT, response)
    return response
  },
  async populateTextContentPages ({ commit }, modulesContentPagesId) {
    let response = await api.AppModules.getTextContentPages(modulesContentPagesId)
    if (!response) {
      throw new Error('No data from API. ;(')
    }
    commit(mutationNames.SET_CONTENT_PAGES, response)
    return response
  },
  editContentPage ({ commit }, contentPageId) {
    commit(mutationNames.SET_CONTENT_EDITING_PAGE, contentPageId)
  },
  closeContentEditingPage ({ commit }) {
    commit(mutationNames.CLEAR_CONTENT_EDITING_DATA)
  },
  cancelContentPageEditing ({ state, commit }) {
    commit(mutationNames.CANCEL_CONTENT_PAGE_EDITING, Object.assign({}, state.BackupContentPage))
    commit(mutationNames.CLEAR_CONTENT_EDITING_DATA)
  },
  undoContentPageEditing ({ state, commit }) {
    commit(mutationNames.CANCEL_CONTENT_PAGE_EDITING, Object.assign({}, state.BackupContentPage))
  },
  updateEditingContentPage ({ commit, state }, payload) {
    commit(mutationNames.UPDATE_CONTENT_PAGE, { Id: state.EditingContentPageId, payload })
  },
  createNewContentPage ({ commit }, payload) {
    commit(mutationNames.CREATE_NEW_CONTENT_PAGE, payload)
  },
  updateNewContentPage ({ commit }, payload) {
    commit(mutationNames.UPDATE_NEW_CONTENT_PAGE, payload)
  },
  async populateTextModule ({ dispatch, commit }, subscriptionModuleId) {
    const response = await api.AppModules.getTextModule(subscriptionModuleId)
    commit(mutationNames.SET_CONTENT_PAGE_PARENT, response || {})
    if (response) {
      dispatch('populateTextContentPages', response.Id)
    } else {
      commit(mutationNames.SET_CONTENT_PAGES, [])
    }
  },

  updateParent ({ commit }, payload) {
    commit(mutationNames.UPDATE_CONTENT_PARENT, payload)
  },
  saveTextModule ({ getters }) {
    return api.AppModules.saveTextModule(getters.Parent)
  },
  patchTextModule ({getters}, payload) {
    return api.AppModules.patchTextModule(getters.Parent.Id, payload)
  },
  addTextContentPage ({ commit }, payload) {
    return api.AppModules.saveTextContentPage(payload)
  },
  copyTextContentPage ({ commit }, payload) {
    return api.AppModules.copyTextContentPage(payload)
  },
  saveTextContentPage ({ commit }, payload) {
    return api.AppModules.saveTextContentPage(payload)
  },
  saveTextContentPages ({ commit }, payload) {
    return api.AppModules.saveTextContentPages(payload)
  },
  deleteTextContentPage ({ commit }, modulesContentPagesId) {
    return api.AppModules.deleteTextContentPage(modulesContentPagesId)
  },
  DeleteContentPageCategory ({ commit }, {modulesContentPagesId, category}) {
    return api.AppModules.DeleteContentPageCategory(modulesContentPagesId, category)
  },
  getPostTemplate ({ rootGetters }, moduleId) {
    return api.system.getPostTemplate(moduleId, rootGetters.language)
  },
  async updateTextContentPageImage ({ getters, commit }, { Id, payload }) {
    const contentPage = getters.ContentPages.find(page => page.Id === Id)
    if (contentPage) {
      await api.AppModules.patchTextContentPage(contentPage.Id, {
        PostImage: payload.PostImage
      })
    }
    commit(mutationNames.UPDATE_CONTENT_PAGE_IMAGE, { Id, payload })
  },
  setFirstTimeOpenValue ({ commit }, payload) {
    commit('setFirstTimeOpenValue', payload)
  },
  updateActiveEventTab ({ commit }, payload) {
    commit('CURRENT_ACTIVE_EVENT_TAB', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/textContent.js